"use client";

import React, { createContext, useContext, useState, ReactNode } from "react";
import cn from "classnames";

interface TabsContextProps {
  activeIndex: number;
  setActiveIndex: (index: number) => void;
}

const TabsContext = createContext<TabsContextProps | undefined>(undefined);

export const useTabs = () => {
  const context = useContext(TabsContext);
  if (!context) {
    throw new Error("useTabs debe usarse dentro de <Tabs>");
  }
  return context;
};

type TabsProps = {
  children: ReactNode;
  background?: string;
}
type TabItemProps ={
  children: ReactNode;
  label: string;
}
const Tabs: React.FC<TabsProps> = ({ children, background }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <TabsContext.Provider value={{ activeIndex, setActiveIndex }}>
        {/* Renderizamos los headers */}
        <div className="flex gap-[10px] mb-8 w-full justify-center">
          {React.Children.map(children, (child, index) => {
            if (!React.isValidElement(child)) return null;
            const { label } = child.props as TabItemProps;
            const isActive = index === activeIndex;
            return (
              <div key={index} className="flex flex-col items-center">
                <button
                  onClick={() => setActiveIndex(index)}
                  className={cn("p-[10px] border cursor-pointer rounded-full font-headings font-normal", {
                    "bg-surface-900 text-surface-100": isActive,
                    "bg-surface-50 text-surface-500 border-surface-500": !isActive,
                  })}
                >
                  {label}
                </button>
                {isActive && <div className="-mt-[10px] flex justify-center ">
                   <svg xmlns="http://www.w3.org/2000/svg" width="28" height="20" viewBox="0 0 28 20" fill="none">
                  <path d="M15.9687 18.0928C14.7678 19.5861 12.4939 19.5861 11.293 18.0928L0.667711 4.88001C-0.910914 2.91696 0.486502 -2.85386e-06 3.00556 -2.63364e-06L24.2562 -7.75851e-07C26.7752 -5.55628e-07 28.1726 2.91696 26.594 4.88002L15.9687 18.0928Z" fill="#18181B" />
                </svg>
                </div>}
                </div>
            );
          })}
        </div>
        {/* Renderizamos el contenido activo */}
        <div>
          {React.Children.map(children, (child, index) =>
            index === activeIndex ? child : null
          )}
        </div>
    </TabsContext.Provider>
  );
};

const TabItem: React.FC<TabItemProps> = ({ children, label }) => {
  return <div id={label} >{children}</div>;
};

export { TabItem };
export default Tabs;